import { createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";
import { isLoggedIn } from "./auth";
import moment from "moment";

const slice = createSlice({
  name: "events",
  initialState: { list: [], loading: false, currentPage:1 },
  reducers: {
    // action => action handler
    eventPosted: (events, action) => {
      events.list.push(action.payload);
    },
    eventEdited: (events, action) => {
      events.list = events.list.filter(event => (event._id !== action.payload._id));
      events.list.push(action.payload);
    },
    eventsRequested: (events, action) => {
      events.loading = true;
    },
    eventsReceived: (events, action) => {
      events.list = action.payload;
      events.loading = false;
      events.currentPage = 1;
    },
    eventsRequestFailed: (events, action) => {
      events.loading = false;
      console.log(action.payload);
    },
    eventsCurrentPageUpdated: (events, action)=>{
      events.currentPage = action.payload
    }
  },
});

export const { eventPosted, eventsRequested, eventsReceived, eventsRequestFailed, eventEdited, eventsCurrentPageUpdated } = slice.actions;

export const updateCurrentPage = (page) => eventsCurrentPageUpdated(page);

const genDateTime = (date, time) => {
  const dateArray = moment(date).format("YYYY/MM/DD").split("/");
  const timeArray = moment(time).format("HH:mm").split(":");

  const year = parseInt(dateArray[0]);
  const month = parseInt(dateArray[1]);
  const day = parseInt(dateArray[2]);
  const hours = parseInt(timeArray[0]);
  const minutes = parseInt(timeArray[1]);

  return new Date(year, month - 1, day, hours, minutes);
};

export const getEvents = () =>
  apiCallBegan({
    url: "/events",
    // url: "/events/upcoming",
    method: "get",
    onSuccess: eventsReceived.type,
    onStart: eventsRequested.type,
    onError: eventsRequestFailed.type,
  });

  export const deleteEvent = (id, active) => (dispatch, getState) => {
    if (!isLoggedIn()) {
      const mustLoginMessage = "You have to login to be able to delete events!";
      window.alert(mustLoginMessage);
      throw {
        response: {
          data: mustLoginMessage,
          status: 400,
        },
      };
    }

    return dispatch(
      apiCallBegan({
        url: `/events/${id}`,
        method: active?"delete":"post",
        onSuccess: eventEdited.type,
        //   onStart: bugsRequested.type,
        //   onError: bugsRequestFailed.type,
      })
    );
  }

  export const editEvent = (event, id, deletedImages) => (dispatch, getState) => {
    if (!isLoggedIn()) {
      const mustLoginMessage = "You have to login to be able to edit events!";
      window.alert(mustLoginMessage);
      throw {
        response: {
          data: mustLoginMessage,
          status: 400,
        },
      };
    }
    const data = { ...event };
  
    const formData = new FormData();
  
    formData.append("title", data.title);
    formData.append("owner", data.owner);
  
    // formData.append("date", data.date);
    // formData.append("time", data.time);
  
    formData.append("omitTime", data.omitTime);
    
    formData.append("dateTime", genDateTime(data.date, data.time));
  
    formData.append("country", data.country);
    formData.append("province", data.province);
    formData.append("town", data.town);
    formData.append("streetAddress", data.streetAddress);
    formData.append("details", data.details);
  
    data.types.forEach((type) => {
      formData.append("types[]", type);
    });
  
    data.contacts.forEach((contact) => {
      formData.append("contacts[]", contact);
    });
  
    deletedImages.forEach((uri)=>{
      formData.append("deletedImages[]", uri);
    })

    data.pictures.forEach((picture) => {
      formData.append("photos", picture);
    });
    
    return dispatch(
      apiCallBegan({
        url: `/events/${id}`,
        method: "put",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
        onSuccess: eventEdited.type,
        //   onStart: bugsRequested.type,
        //   onError: bugsRequestFailed.type,
      })
    );
  };

export const postEvent = (event) => (dispatch, getState) => {
  if (!isLoggedIn()) {
    const mustLoginMessage = "You have to login to be able to post events!";
    window.alert(mustLoginMessage);
    throw {
      response: {
        data: mustLoginMessage,
        status: 400,
      },
    };
  }
  const data = { ...event };

  const formData = new FormData();

  formData.append("omitTime", data.omitTime);

  formData.append("adminGen", data.adminGen);
  formData.append("title", data.title);
  formData.append("owner", data.owner);

  // formData.append("date", data.date);
  // formData.append("time", data.time);

  formData.append("dateTime", genDateTime(data.date, data.time));

  formData.append("country", data.country);
  formData.append("province", data.province);
  formData.append("town", data.town);
  formData.append("streetAddress", data.streetAddress);
  formData.append("details", data.details);

  data.types.forEach((type) => {
    formData.append("types[]", type);
  });

  data.contacts.forEach((contact) => {
    formData.append("contacts[]", contact);
  });

  data.pictures.forEach((picture) => {
    formData.append("photos", picture);
  });

  return dispatch(
    apiCallBegan({
      url: "/events",
      method: "post",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
      onSuccess: eventPosted.type,
      //   onStart: bugsRequested.type,
      //   onError: bugsRequestFailed.type,
    })
  );
};

export default slice.reducer;
